import component from './PrivateRowConstructor.vue'
export default component
